// This component is deprecated. New design does not use this component.
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { observer } from "mobx-react";

import Button from '@mui/material/Button';

import { useStyles } from "./styles";
import useWidgetTheme from "../../../commons/widgetTheme";
import getCommonUIStyles from "../../../commons/uiStyles";

function PrimaryButton(props) {
  const {
    isDisabled = false,
    onClick = () => {},
    textLabel = 'Button',
  } = props;

  const {
    widget,
    widgetTheme,
    hasCustomCSS,
    cssCustomClasses,
}  = useWidgetTheme();

  const classes = useStyles({
    widget,
    widgetTheme,
    hasCustomCSS,
    cssCustomClasses,
    commonUIStyles: getCommonUIStyles({ widgetTheme, widget }),
  });

  return (
    <Button
      disabled={isDisabled}
      classes={{
        root: classNames([
          "Button__button___2a549",
          "ecal-primary-button",
          classes.button,
        ]),
      }}
      onClick={(e) => onClick(e)}
    >
      { textLabel}
    </Button>
  );
}

PrimaryButton.propTypes = {
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  textLabel: PropTypes.any,
};

export default observer(PrimaryButton);
